import React, { useState, useEffect } from 'react';
import { Box, Text, Button, Link as ChakraLink, Flex, CloseButton, useColorModeValue } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

const COOKIE_CONSENT_KEY = 'megalithMapsCookieConsent';

export default function CookieConsentBanner() {
  const [isVisible, setIsVisible] = useState(false);
  // Use semantic tokens from theme for better integration
  const bgColor = 'bg.surface';
  const textColor = 'text.default';
  const linkColor = 'text.link';
  const borderColor = 'border.default';

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setIsVisible(false);
    // Disable non-essential cookies/analytics here if needed
    // For example, you could dispatch an event or call analytics.disable()
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Box
      position="fixed"
      bottom="0"
      left="0"
      right="0"
      bg={bgColor}
      color={textColor}
      borderTop="1px solid"
      borderColor={borderColor}
      p={4}
      zIndex="banner"
      boxShadow="xl"
      backdropFilter="blur(8px)"
    >
      <Flex 
        direction={{ base: 'column', md: 'row' }} 
        alignItems={{ base: 'stretch', md: 'center' }} 
        maxW="container.xl" 
        mx="auto" 
        gap={{ base: 3, md: 4 }}
      >
        <Text fontSize="sm" flexGrow={1} textAlign={{ base: 'center', md: 'left' }}>
          This website uses cookies to improve your browsing experience and analyze site traffic. 
          By clicking 'Accept', you consent to our use of cookies. 
          You can learn more by reading our <ChakraLink as={RouterLink} to="/privacy" color={linkColor} fontWeight="bold" isExternal={false}>Privacy Policy</ChakraLink>.
        </Text>
        <Flex 
          direction={{ base: 'column', sm: 'row' }} 
          gap={2}
          flexShrink={0}
          minW={{ base: 'full', md: 'auto' }}
        >
          <Button 
            variant="outline"
            borderColor="border.default"
            color="text.muted"
            _hover={{ 
              bg: useColorModeValue('gray.50', 'whiteAlpha.100'),
              borderColor: 'border.heavy',
              color: 'text.default'
            }}
            size={{ base: 'md', md: 'sm' }}
            onClick={handleDecline}
            fontWeight="medium"
            borderRadius="md"
            flex={{ base: 1, sm: 'none' }}
          >
            Decline
          </Button>
          <Button 
            bg="interactive.primary"
            color={useColorModeValue('white', 'gray.800')}
            _hover={{ bg: 'interactive.hover', transform: 'translateY(-1px)' }}
            _active={{ bg: 'interactive.pressed', transform: 'translateY(0px)' }}
            size={{ base: 'md', md: 'sm' }}
            onClick={handleAccept}
            fontWeight="medium"
            borderRadius="md"
            flex={{ base: 1, sm: 'none' }}
          >
            Accept
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
}
